module.exports = __webpack_public_path__ + "img/banner1.2f4b301f.png";